// Types
import type { IFilterBundle } from '../../components/filter/FilterPanel'
import type { ITableEmptyState } from '../../components/layout/Table'

interface IOptions {
  filters: IFilterBundle
  searchTerm?: string
  extraHasActive?: boolean
  onClear: () => void
}

// The "no results" state of a filtered list, shared by Table's emptyState and
// FilterEmptySearchState: a button clears the filters, or else the search
export const getFilterEmptyState = (
  t: (key: string) => string,
  { filters, searchTerm, extraHasActive, onClear }: IOptions
): ITableEmptyState => {
  const hasActiveFilters = filters.hasActiveFilters || !!extraHasActive

  return {
    title: hasActiveFilters
      ? t('general.forms.emptyFilter')
      : t('general.forms.emptySearch'),
    action:
      hasActiveFilters || searchTerm
        ? {
            caption: hasActiveFilters
              ? t('general.forms.clearFilter')
              : t('general.forms.clearSearch'),
            onClick: onClear,
          }
        : undefined,
  }
}
